import styled, { keyframes } from "styled-components";

/* mesma linguagem visual de Contratos e Avisos de Entrega */

const surgir = keyframes`
  from { opacity: 0; transform: translateY(10px); }
  to   { opacity: 1; transform: translateY(0); }
`;

const girar = keyframes`
  to { transform: rotate(360deg); }
`;

const cartao = `
  background: #ffffff;
  border-radius: 14px;
  box-shadow: 0 1px 3px rgba(16, 44, 76, 0.08), 0 6px 18px rgba(16, 44, 76, 0.04);
`;

export const Pagina = styled.div`
  background: #f5f5f5;
  min-height: 100vh;
  padding: 22px 24px 48px;
  font-family: 'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif;
  color: #1a2740;
`;

export const Cabecalho = styled.header`
  ${cartao}
  padding: 22px 26px;
  margin-bottom: 18px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 24px;
  flex-wrap: wrap;
  animation: ${surgir} 0.35s ease-out both;
`;

export const Identidade = styled.div`
  display: flex;
  align-items: center;
  gap: 16px;

  h1 { font-size: 22px; font-weight: 800; margin: 0 0 3px; letter-spacing: -0.2px; }
  p { margin: 0; font-size: 13.5px; color: #7a8fa6; max-width: 620px; line-height: 1.5; }
  strong { color: #024995; font-weight: 700; }
`;

export const IconeTitulo = styled.div`
  width: 46px; height: 46px; border-radius: 12px;
  display: flex; align-items: center; justify-content: center;
  color: #ffffff; font-size: 19px; flex-shrink: 0;
  background: #024995;
  background-image: linear-gradient(135deg, #024995 0%, #009bd9 100%);
`;

export const Contadores = styled.div`
  display: flex; gap: 10px; flex-wrap: wrap;
`;

export const Contador = styled.div<{ $cor: string; $fundo: string; $borda: string }>`
  min-width: 104px; padding: 10px 14px; border-radius: 12px;
  background: ${(p) => p.$fundo};
  border: 1.5px solid ${(p) => p.$borda};
  text-align: center;

  strong { display: block; font-size: 20px; font-weight: 800; color: ${(p) => p.$cor}; line-height: 1.2; }
  span { display: block; font-size: 10.5px; font-weight: 800; letter-spacing: 0.7px;
         text-transform: uppercase; color: #8698ab; margin-top: 2px; }
`;

export const Filtros = styled.section`
  ${cartao}
  padding: 18px 22px;
  margin-bottom: 18px;
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(170px, 1fr));
  gap: 14px;
  align-items: end;
  animation: ${surgir} 0.35s ease-out 0.04s both;
`;

export const Campo = styled.div`
  min-width: 0;

  label {
    display: block; font-size: 10.5px; font-weight: 800; letter-spacing: 0.9px;
    text-transform: uppercase; color: #8698ab; margin-bottom: 6px;
  }

  .entrada { position: relative;
    i { position: absolute; left: 13px; top: 50%; transform: translateY(-50%);
        font-size: 13px; color: #b3c1d1; pointer-events: none; }
  }

  input {
    width: 100%; border: 1.5px solid #e8eef5; border-radius: 10px;
    padding: 10px 12px 10px 34px; font-size: 13.5px; color: #1a2740;
    background: #ffffff; outline: none; transition: border-color 0.15s ease;
    &:focus { border-color: #009bd9; }
  }
`;

export const Botao = styled.button<{ $primario?: boolean }>`
  border: 1.5px solid ${(p) => (p.$primario ? "transparent" : "#e8eef5")};
  background: ${(p) => (p.$primario ? "#024995" : "#ffffff")};
  background-image: ${(p) => (p.$primario ? "linear-gradient(135deg,#024995 0%,#009bd9 100%)" : "none")};
  color: ${(p) => (p.$primario ? "#ffffff" : "#5b6f85")};
  border-radius: 10px; padding: 10px 16px; font-size: 13px; font-weight: 700;
  cursor: pointer; height: 41px; transition: all 0.15s ease;

  i { margin-right: 7px; }

  &:hover:not(:disabled) {
    ${(p) => (p.$primario ? "filter: brightness(1.08);" : "border-color:#024995;color:#024995;")}
  }
  &:disabled { opacity: 0.6; cursor: not-allowed; }
`;

export const Atalhos = styled.div`
  display: flex; gap: 8px; flex-wrap: wrap; margin-bottom: 18px;

  button {
    border: 1.5px solid #e8eef5; background: #ffffff; color: #5b6f85;
    border-radius: 20px; padding: 6px 14px; font-size: 12.5px; font-weight: 700; cursor: pointer;
    &:hover { border-color: #024995; color: #024995; }
  }
`;

export const Tabela = styled.section`
  ${cartao}
  animation: ${surgir} 0.35s ease-out 0.08s both;
  overflow: hidden;
`;

const grade = `
  display: grid;
  grid-template-columns: minmax(0, 2fr) 90px 90px 100px minmax(0, 1.1fr) minmax(0, 1.1fr);
  gap: 14px;
  align-items: center;
`;

export const Titulos = styled.div`
  ${grade}
  padding: 13px 24px;
  background: #f7fafd;
  border-bottom: 1.5px solid #e8eef5;

  span { font-size: 10.5px; font-weight: 800; letter-spacing: 0.9px;
         text-transform: uppercase; color: #8698ab; }

  @media (max-width: 1000px) { display: none; }
`;

export const Linha = styled.div`
  ${grade}
  padding: 14px 24px;
  border-bottom: 1px solid #f0f4f8;

  &:last-child { border-bottom: none; }
  &:hover { background: #fafcfe; }

  @media (max-width: 1000px) {
    grid-template-columns: 1fr; gap: 8px; padding: 16px 20px;
    border-bottom: 8px solid #f5f5f5;
  }
`;

export const Celula = styled.div`
  min-width: 0;

  .nome { font-size: 14.5px; font-weight: 700; color: #1a2740; overflow-wrap: anywhere; }
  .numero { font-size: 15px; font-weight: 700; color: #1a2740; }
  .forte { font-size: 17px; font-weight: 800; color: #024995; }
  .apoio { font-size: 12px; color: #8698ab; }

  /* nomes de quem editou: cabem embaixo do número, sem empurrar a coluna */
  .quem {
    display: block;
    font-size: 11.5px;
    color: #8698ab;
    line-height: 1.35;
    margin-top: 2px;
    overflow-wrap: anywhere;
  }

  .rotulo {
    display: none; font-size: 10px; font-weight: 800; letter-spacing: 0.8px;
    text-transform: uppercase; color: #b3c1d1; margin-bottom: 2px;
  }

  @media (max-width: 1000px) { .rotulo { display: block; } }
`;

/*
  Nome de quem editou (ou de quem teve a correção editada).

  Um por linha, em etiqueta azul: lado a lado e em texto corrido, dois ou três
  nomes viravam uma frase difícil de ler na largura da coluna.
*/
export const Etiqueta = styled.span`
  display: block;
  width: fit-content;
  max-width: 100%;
  margin-top: 4px;
  padding: 3px 9px;
  border-radius: 10px;
  background: #024995;
  color: #ffffff;
  font-size: 11.5px;
  font-weight: 600;
  line-height: 1.35;
  overflow-wrap: anywhere;

  /* a quantidade, quando a mesma pessoa mexeu em mais de uma */
  strong {
    font-weight: 800;
    opacity: 0.85;
    margin-left: 4px;
  }
`;

/*
  "+2 outros": abre a lista completa num modal. É botão de verdade — recebe
  foco e responde ao Enter — com a mesma forma das etiquetas.
*/
export const BotaoResto = styled.button`
  display: block;
  width: fit-content;
  max-width: 100%;
  margin-top: 4px;
  padding: 3px 9px;
  border: 1px solid #c5e0f7;
  border-radius: 10px;
  background: #eef6fd;
  color: #0b5a92;
  font-size: 11.5px;
  font-weight: 700;
  line-height: 1.35;
  cursor: pointer;
  transition: background 0.15s ease;

  &:hover {
    background: #dceefb;
  }
`;

/* lista dentro do modal: nome à esquerda, quantidade à direita */
export const ItemDetalhe = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  padding: 9px 2px;
  border-bottom: 1px solid #f0f4f8;
  font-size: 14px;

  &:last-child {
    border-bottom: none;
  }

  .nome {
    color: #1a2740;
    font-weight: 600;
    overflow-wrap: anywhere;
  }

  .quantas {
    flex-shrink: 0;
    padding: 2px 10px;
    border-radius: 10px;
    background: #024995;
    color: #ffffff;
    font-size: 12px;
    font-weight: 700;
  }
`;

export const Vazio = styled.div`
  padding: 56px 24px; text-align: center;

  i { font-size: 40px; color: #cfdae7; margin-bottom: 14px; display: block; }
  h3 { font-size: 16px; font-weight: 700; margin: 0 0 6px; }
  p { font-size: 13.5px; color: #8698ab; margin: 0; }
`;

export const Carregando = styled.div`
  padding: 56px 24px; text-align: center; color: #8698ab; font-size: 13.5px;

  &::before {
    content: ""; display: block; width: 30px; height: 30px; margin: 0 auto 14px;
    border: 3px solid #e8eef5; border-top-color: #024995; border-radius: 50%;
    animation: ${girar} 0.8s linear infinite;
  }
`;

export const Nota = styled.div`
  ${cartao}
  padding: 14px 18px; margin-bottom: 18px;
  display: flex; gap: 12px; align-items: flex-start;
  border-left: 4px solid #009bd9;
  font-size: 13px; color: #5b6f85; line-height: 1.55;

  i { color: #009bd9; font-size: 15px; margin-top: 2px; }
  strong { color: #1a2740; }
`;
